// extracted by mini-css-extract-plugin
module.exports = {"carousel":"WeekendGetaways-module__carousel___8Pf0h","disclaimer":"WeekendGetaways-module__disclaimer___GgmHt","mobileContainer":"WeekendGetaways-module__mobileContainer___Zi4wN"};